module.exports = __webpack_public_path__ + "img/mlb-back-2-p-1080.9f16f034.png";